import React from 'react'
import HelpOverlay from '../../utils/helpOverlay'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { Tabs, Tab, Checkbox } from 'react-bootstrap'
import * as defaultConst from '../../../constants/default_constants'

import AttrArrayInput from '../../input/attrarray'
import DateInput from '../../input/date'
import SelectMultipleValsInput from '../../input/select_multiple'
import VideoTypeInput from '../../input/videotype'
import TextArea from '../../input/textArea'

import BundledFilms from '../parts/bundledFilms'
import FilmEvaluation from '../parts/evaluation'
import FilmRating from '../parts/film_rating'
import HVSDEdit from '../parts/hvsd'
import LanguageTabs from '../parts/languages'
import LanguagesTab from '../parts/languages_tab'
import OMDBButton from '../parts/omdbButton'
import RolesEdit from '../parts/roles'
import SeriesTab from '../parts/series_tab'

export default class CommonEditForm extends React.Component {
  constructor () {
    super()
    this.assetRefs = {}
    this.episodesTab = 4
    this.scrollWaiting = 400
  }

  gotoRefs (goto, lang) {
    const gotoLang = lang && (goto.concat('-') + lang)
    // setTimeout because animation between tabs
    setTimeout(() => {
      this.assetRefs[goto].scrollIntoView(true)
      window.scrollBy(0, -60)
      gotoLang && this.assetRefs[gotoLang] && this.assetRefs[gotoLang].focus()
    }, this.scrollWaiting)
    // console.log(goto, lang, gotoLang, this.assetRefs)
  }

  componentDidUpdate () {
    const cv = this.props.store && this.props.store.cv
    const currentId = cv && cv.record && cv.record.has('id') && cv.record.get('id')

    if (currentId && this.assetRefs[currentId] &&
      this.props.store.assetTabs.common === this.episodesTab) {
      setTimeout(
        () => this.assetRefs[currentId]
          .scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }), this.scrollWaiting
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
      )
    }
  }

  changeAttrArrayValue (platform, name, value) {
    this.props.store.changeAttrArrayValue(platform, name, value)
  }

  render () {
    const { store, updateField, arrayMap, disabled, isBundleType, assetTabs, autoSLug, autoName } = this.props
    const entity = store.cv.record
    const errors = store.cv.errors
    const col1 = 'col-sm-12 col-md-6 col-lg-4'
    const col2 = 'col-sm-12 col-md-6 col-lg-3'
    const col3 = 'col-sm-12 col-md-12 col-lg-5'
    const col4 = 'col-sm-12 col-md-6 col-lg-12'
    const slugDisabled = disabled || entity.get('id') !== undefined || entity.get('updated_at') !== undefined
    let ek = 1

    const bundleOption = store.options.get('video_type').find(v => v.value === 'BUNDLE')
    isBundleType && entity.set('video_type', 'BUNDLE')

    const _updateSlugField = (attr, val) => {
      updateField(attr, store.toSlug(val))
    }

    /*
    function updateDistTitle (attr, val) {
      // write to slug if creating
      if (!entity.has('id') && (!entity.has('slug') || entity.get('slug').length === 0)) {
        updateField('slug', store.toSlug(val))
      }
      updateField(attr, val)
    }
    */

    const isSeries = store.cv.record.has('video_type') && store.cv.record.get('video_type') &&
      store.cv.record.get('video_type') === 'SERIES'

    const isSeason = store.cv.record.has('video_type') && store.cv.record.get('video_type') &&
      store.cv.record.get('video_type') === 'SEASON'

    const isEpisode = store.cv.record.has('video_type') && store.cv.record.get('video_type') &&
      store.cv.record.get('video_type') === 'EPISODE'

    const seriesIdfromEpisode = isEpisode && store.options.get('seasons')
      .find(f => f.id && parseInt(f.id) === parseInt(store.cv.record.get('parent_id')))

    const seriesId = isSeries ? store.cv.record.get('id') : (isSeason
      ? store.cv.record.get('parent_id')
      : (isEpisode ? seriesIdfromEpisode && seriesIdfromEpisode.parent_id : null)
    )

    const updateFieldTitle = (attr, val) => {
      if (!slugDisabled && store.cv.autoValues.slug) {
        _updateSlugField('slug', val)
      }
      if (!slugDisabled && store.cv.autoValues.name) {
        entity.get('attrs')
          .find(i => i.lang === defaultConst.DEFAULT_LANG && i.name === 'name')
          .value = val
      }
      updateField(attr, val)
    }

    const handleCheckbox = (e, type) => {
      store.cv.autoValues[type] = e.target.checked
      type === 'slug' && e.target.checked && _updateSlugField('slug', entity.get('title') || '')
      type === 'name' && e.target.checked && (entity.get('attrs')
        .find(i => i.lang === defaultConst.DEFAULT_LANG && i.name === 'name')
        .value = entity.get('title') || '')
    }

    return (
      <div>
        <Tabs onSelect={tab => store.assetTabEvent('common', tab)}
          activeKey={assetTabs < this.episodesTab || (isSeries || isSeason || isEpisode)
            ? assetTabs
            : 1}>
          <Tab eventKey={ek++} title={
            <div>
              {store.__('Settings')}
              <HelpOverlay store={store} path={'films/common/settings'} />
            </div>}>

            {isBundleType && !store.cv.record.has('id') &&
            <div className='alert alert-dismissible alert-info'>
              <p>{store.__('You selected BUNDLE video type. It is useds for joining several films together. But not for series/seasons/episodes.')}</p>
            </div>}

            <div className='row'>
              <div className={col1}>
                <TextInput
                  attr='title'
                  disabled={disabled}
                  errors={errors}
                  label={store.__('FilmCargo distribution title')}
                  onChange={updateFieldTitle}
                  record={entity} />

                {!slugDisabled && <div className='row' style={{ marginTop: '-1em' }}>
                  <div className='col-xs-6'>
                    <Checkbox checked={autoSLug} onChange={e => handleCheckbox(e, 'slug')}>
                      {store.__('Auto-generated slug')}
                    </Checkbox>
                  </div>
                  <div className='col-xs-6'>
                    <Checkbox checked={autoName} onChange={e => handleCheckbox(e, 'name')}>
                      {store.__('Copy to distribution title')}
                    </Checkbox>
                  </div>
                </div>}

                <TextInput
                  label={<span>{store.__('Slug')}
                    {entity.has('slug') && navigator.clipboard &&
                    <i className='glyphicon glyphicon-copy copy-to-clipboard'
                      onClick={() => { navigator.clipboard.writeText(entity.get('slug')) }}
                      title={store.__('Click to copy to the clipboard')} />}
                  </span>
                  }
                  attr={'slug'}
                  record={entity}
                  disabled={slugDisabled || autoSLug}
                  onChange={_updateSlugField}
                  errors={errors} />
                <TextInput
                  label={'IMDB ID'}
                  attr={'imdb_id'}
                  record={entity}
                  onChange={updateField}
                  errors={errors} disabled={disabled} />

                {!disabled && <OMDBButton store={store} />}
                <hr ref={el => { this.assetRefs['common-lang'] = el }} />

                <h5 className='card-title'>{store.__('Metedata language variations')}
                  <HelpOverlay store={store} path='films/common/lang_title_synopsis' />
                </h5>
                {<LanguageTabs
                  assetRefs={this.assetRefs}
                  assetRefsKey='common-lang'
                  autoName={!slugDisabled && autoName}
                  disabled={disabled}
                  errors={errors}
                  store={store}
                  updateField={updateField} />}

                <SelectMultipleValsInput
                  label={'Countries of origin'}
                  attr={'origcountries'}
                  record={entity}
                  onChange={updateField}
                  errors={errors}
                  store={store}
                  optionsrecord={store.options}
                  optionsattr={'Countries_alternative'} disabled={disabled} />
                <SelectMultipleValsInput
                  label={'Original versions (languages)'}
                  attr={'origlangs'}
                  record={entity}
                  onChange={updateField}
                  errors={errors}
                  store={store}
                  optionsrecord={store.options}
                  optionsattr={'OriginalVersionLanguages'} disabled={disabled} />
              </div>

              <div className={col2}>
                <VideoTypeInput
                  store={store}
                  updateField={updateField}
                  errors={errors} disabled={disabled || isBundleType} />
                <hr />

                <AttrArrayInput
                  attrArray={entity.get('attrs')}
                  attrs={arrayMap}
                  errors={errors} disabled={disabled}
                  label={store.__('FilmCargo "internal" note for all users')}
                  name='fcnote'
                  platform='common'
                  rows={3}
                  updateField={this.changeAttrArrayValue.bind(this)}
                  componentClass='textarea'
                  InputComponent={TextArea} />
                <SelectMultipleValsInput
                  attr='filmcargoFilmLabels'
                  disabled={disabled}
                  errors={errors}
                  label={store.__('FilmCargo film labels')}
                  onChange={updateField}
                  optionsattr='FilmcargoFilmLabels'
                  optionsrecord={store.options}
                  record={entity}
                  store={store} />
                <hr />

                <SelectMultipleValsInput
                  label={'Genres'}
                  attr={'cats'}
                  record={entity}
                  onChange={updateField}
                  optionsrecord={store.options}
                  errors={errors}
                  store={store}
                  optionsattr={'Genres'} disabled={disabled} />
                <SelectMultipleValsInput
                  label={'Keywords'}
                  addNew={true}
                  attr={'keywords'}
                  record={entity}
                  onChange={updateField}
                  optionsrecord={store.options}
                  errors={errors}
                  store={store}
                  optionsattr={'Keywords'} disabled={disabled} />
                <SelectMultipleValsInput
                  label={'Film format category'}
                  attr={'format'}
                  record={entity}
                  onChange={updateField}
                  optionsrecord={store.options}
                  errors={errors}
                  store={store}
                  optionsattr={'FormatCategory'} disabled={disabled} />
                <AttrArrayInput
                  label={store.__('Production')}
                  platform='common'
                  name='production'
                  attrs={arrayMap}
                  attrArray={entity.get('attrs')}
                  InputComponent={TextInput}
                  updateField={this.changeAttrArrayValue.bind(this)}
                  errors={errors} disabled={disabled} />
                <AttrArrayInput
                  label={store.__('Year of production')}
                  platform='common'
                  name='year'
                  attrs={arrayMap}
                  type='number'
                  attrArray={entity.get('attrs')}
                  InputComponent={TextInput}
                  updateField={this.changeAttrArrayValue.bind(this)}
                  errors={errors} disabled={disabled} />
                <AttrArrayInput
                  label={store.__('Website')}
                  platform='common'
                  name='website'
                  attrs={arrayMap}
                  attrArray={entity.get('attrs')}
                  InputComponent={TextInput}
                  updateField={this.changeAttrArrayValue.bind(this)}
                  errors={errors} disabled={disabled} />
                <AttrArrayInput
                  label={store.__('Runtime (in minutes)')}
                  platform='common'
                  name='runtime'
                  attrs={arrayMap}
                  type='number'
                  attrArray={entity.get('attrs')}
                  InputComponent={TextInput}
                  updateField={this.changeAttrArrayValue.bind(this)}
                  errors={errors} disabled={disabled} />
                <AttrArrayInput
                  label={store.__('Theatrical release date')}
                  platform='common'
                  name='released'
                  attrs={arrayMap}
                  attrArray={entity.get('attrs')}
                  InputComponent={DateInput}
                  updateField={this.changeAttrArrayValue.bind(this)}
                  errors={errors} disabled={disabled} />
                <AttrArrayInput
                  label={store.__('DVD')}
                  platform='common'
                  name='dvd'
                  attrs={arrayMap}
                  attrArray={entity.get('attrs')}
                  InputComponent={TextInput}
                  updateField={this.changeAttrArrayValue.bind(this)}
                  errors={errors} disabled={disabled} />
              </div>

              <div className={col3}>
                <div className='row'>
                  {isBundleType ? <div className={col4}>
                    <BundledFilms store={store} updateField={updateField} disabled={disabled} disabledRemove={disabled} />
                  </div> : null}
                  <div className={col4}>
                    <RolesEdit store={store} updateField={updateField} disabled={disabled} disabledRemove={disabled} />
                  </div>
                  <div className={col4}>
                    <HVSDEdit store={store} disabled={disabled} disabledRemove={disabled} />
                  </div>
                  <div className={col4}>
                    <FilmEvaluation entity={entity} store={store} />
                  </div>
                </div>
              </div>
            </div>
          </Tab>

          <Tab eventKey={ek++} title={<div>{store.__('Metadata language variations')} <HelpOverlay store={store} path={'films/common/languages'} /></div>}>
            <LanguagesTab
              disabled={disabled} store={store}
              gotoRefs={this.gotoRefs.bind(this)}
              assetRefs={this.assetRefs} />
          </Tab>

          <Tab eventKey={ek++} title={<div>{store.__('Ratings')} <HelpOverlay store={store} path={'films/common/ratings'} /></div>}>
            <FilmRating entity={entity} store={store} disabled={disabled} disabledRemove={disabled} />
          </Tab>

          {entity.has('video_type') && ['SERIES', 'SEASON', 'EPISODE'].includes(entity.get('video_type')) &&
            <Tab eventKey={ek++} title={<div>{store.__('Episodes')} <HelpOverlay store={store} path={'films/common/episodes'} /></div>}>
              <SeriesTab
                store={store}
                assetRefs={this.assetRefs}
                isEpisode={isEpisode}
                isSeries={isSeries}
                isSeason={isSeason}
                originalSeriesId={seriesId}
              />
            </Tab>
          }
        </Tabs>
      </div>
    )
  }
}
